import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Card, Select, InputNumber, message, notification } from 'antd';
import { CreateRefundPayment, GetAllPaymentByID, GetretreatByID, GetRetreatReqByUser } from '../../api/AdminService';
import { useNavigate } from 'react-router-dom';
const { Option } = Select;
const { TextArea } = Input;
const id = JSON.parse(localStorage.getItem('id'));
const UserRefund = () => {
  const [form] = Form.useForm();
  const [retreatRegId, setRetreatRegId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [retreatNames, setRetreatNames] = useState({});
  const navigate = useNavigate();
  const GetRetreatReg = async (id) => {
    try {
      const res = await GetRetreatReqByUser(id);
      if (res.status === 200) {
        console.log(res.data);
        const retreatPromises = res.data.data.map(async item => {
          const res = await GetretreatByID(item.retreatId);
          if (res.status === 200 && res.data.status === 'Open') {
            setRetreatNames(prev => ({ ...prev, [item.retreatId]: res.data.name }));
            return item;
          }
          return null;
        });

        const results = await Promise.all(retreatPromises);
        const validRetreats = results.filter(item => item !== null);
        setRetreatRegId(validRetreats);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetRetreatReg(id);
  }, [id]);

  const onFinish = async (values) => {
    console.log('Received values:', values);
    setLoading(true);
    try {
      const res = await CreateRefundPayment(
        values.retreatRegId,
        values.emailPaypal,
        values.refundReason,
      );

      if (res.status === 201) {
        console.log(res);
        notification.success({
          message: "Refund Successfully"
        });
      }
      setTimeout(() => {
        setLoading(false);
        navigate('/');
      }, 5000);
    } catch (err) {
      console.log(err.response);
      notification.error({
        message: `${err.response.data.message}`
      });
      if (loading && err.response) {
        setLoading(false);
        form.resetFields();
      }
    }
  };

  return (
    <div className="pb-4 mb-4 mt-2 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-1   sm:pt-1 sm:pb-6 sm:px-6  ">
      <h1 className="text-3xl font-bold mb-6">Refund</h1>
      <div style={{ marginBottom: '10px', fontSize: '15px', color: 'gray' }}>The system will automatically refund retreat for you. Please wait or come back to check after a few minutes after the refund. </div>
      <Form
        form={form}
        name="refund_request"
        onFinish={onFinish}
        layout="vertical"
      >
        <Form.Item
          name="retreatRegId"
          label={<span style={{ fontSize: '18px' }}>Retreat</span>}
          rules={[{ required: true, message: 'Please input your Retreat!' }]}
        >
          <Select
            placeholder="Choose Retreat you want to refund"
          >
            {retreatRegId.map((item) => (
              <Option key={item.id} value={item.id}>
                {retreatNames[item.retreatId]}
              </Option>
            ))}

          </Select>
        </Form.Item>

        <Form.Item
          name="refundReason"
          label={<span style={{ fontSize: '18px' }}>Reason for refund</span>}
          rules={[{ required: true, message: 'Please provide a reason for the refund!' }]}
        >
          <TextArea rows={4} placeholder="Please explain why you're requesting a refund" />
        </Form.Item>

        <Form.Item
          name="emailPaypal"
          label={<span style={{ fontSize: '18px' }}>Email Paypal</span>}
          rules={[{ required: true, message: 'Please enter the email paypal!' }]}
        >
          <Input
            style={{ width: '100%' }}
            placeholder="Enter the email"

          />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading}>
            {loading ? "Processing..." : "Submit Refund Request"}
          </Button>
        </Form.Item>
      </Form>

    </div>
  );
}

export default UserRefund